import * as React from 'react';

import { PromoAuthor } from './PromoAuthor';
import { PromoDescription } from './PromoDescription';
import { PromoEnd } from './PromoEnd';

interface IPromoInfoProps {
  endDate?: string | null;
  description?: string | null;
  villageLogoUrl?: string | null;
  villageName?: string | null;
}

export function PromoInfo({ endDate, description, villageLogoUrl, villageName }: IPromoInfoProps) {
  return (
    <div>
      {endDate && <PromoEnd end={endDate} />}
      {description && <PromoDescription description={description} />}
      {villageName && <PromoAuthor villageName={villageName} villageLogoUrl={villageLogoUrl} />}
    </div>
  );
}
